import { useQuery, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables>(endpoint: string, requestInit: RequestInit, query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint, {
      method: 'POST',
      ...requestInit,
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bytes: { input: any; output: any; }
};

export enum GqlChain {
  Bepolia = 'BEPOLIA',
  Berachain = 'BERACHAIN'
}

export type GqlRewardVaultSnapshot = {
  __typename?: 'GqlRewardVaultSnapshot';
  activeIncentivesValueUsd: Scalars['String']['output'];
  apr: Scalars['String']['output'];
  chain: GqlChain;
  id: Scalars['ID']['output'];
  rewardCapturePercentage: Scalars['Float']['output'];
  timestamp: Scalars['Int']['output'];
  tvl: Scalars['String']['output'];
  vaultAddress: Scalars['Bytes']['output'];
};

export enum GqlRewardVaultSnapshotDataRange {
  AllTime = 'ALL_TIME',
  NinetyDays = 'NINETY_DAYS',
  SevenDays = 'SEVEN_DAYS',
  SixtyDays = 'SIXTY_DAYS',
  ThirtyDays = 'THIRTY_DAYS'
}

export enum GqlRewardVaultSnapshotResolution {
  Day = 'DAY',
  Hour = 'HOUR'
}

export type Query = {
  __typename?: 'Query';
  polGetRewardVaultSnapshots: Array<GqlRewardVaultSnapshot>;
};


export type QueryPolGetRewardVaultSnapshotsArgs = {
  chain: GqlChain;
  range?: InputMaybe<GqlRewardVaultSnapshotDataRange>;
  resolution?: InputMaybe<GqlRewardVaultSnapshotResolution>;
  vaultAddress: Scalars['String']['input'];
};

export type GetVaultHistoryQueryVariables = Exact<{
  vaultId: Scalars['String']['input'];
  chain: GqlChain;
  resolution?: InputMaybe<GqlRewardVaultSnapshotResolution>;
  range?: InputMaybe<GqlRewardVaultSnapshotDataRange>;
}>;


export type GetVaultHistoryQuery = { __typename?: 'Query', polGetRewardVaultSnapshots: Array<{ __typename?: 'GqlRewardVaultSnapshot', timestamp: number, apr: string }> };



export const GetVaultHistoryDocument = `
    query GetVaultHistory($vaultId: String!, $chain: GqlChain!, $resolution: GqlRewardVaultSnapshotResolution = DAY, $range: GqlRewardVaultSnapshotDataRange = NINETY_DAYS) {
  polGetRewardVaultSnapshots(
    chain: $chain
    range: $range
    resolution: $resolution
    vaultAddress: $vaultId
  ) {
    timestamp
    apr
  }
}
    `;

export const useGetVaultHistoryQuery = <
      TData = GetVaultHistoryQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetVaultHistoryQueryVariables,
      options?: Omit<UseQueryOptions<GetVaultHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVaultHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVaultHistoryQuery, TError, TData>(
      {
    queryKey: ['GetVaultHistory', variables],
    queryFn: fetcher<GetVaultHistoryQuery, GetVaultHistoryQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetVaultHistoryDocument, variables),
    ...options
  }
    )};

useGetVaultHistoryQuery.document = GetVaultHistoryDocument;

useGetVaultHistoryQuery.getKey = (variables: GetVaultHistoryQueryVariables) => ['GetVaultHistory', variables];


useGetVaultHistoryQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetVaultHistoryQueryVariables) => fetcher<GetVaultHistoryQuery, GetVaultHistoryQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetVaultHistoryDocument, variables);
